import { DataProvider } from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";

export type MedicineSectionForm = {
  imageUrl?: string;
  description?: string;
};

const MEDICINE_SECTION_URL = "/cms/medicine/section";

export const medicineSectionDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getOne: async ({ resource, id }) => {
      try {
        const { data } = await httpClient.get(MEDICINE_SECTION_URL);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      variables,
    }: {
      id: string;
      resource: string;
      variables: MedicineSectionForm;
    }) => {
      try {
        const { data } = await httpClient.post(
          `${MEDICINE_SECTION_URL}/upsert`,
          variables
        );

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
